export default __webpack_public_path__ + "static/media/info-circle.e22bdc30.svg";